export default __webpack_public_path__ + "static/media/nublado.18969e68.svg";